import { render, staticRenderFns } from "./batch-query-info.vue?vue&type=template&id=73f315f4&scoped=true"
import script from "./batch-query-info.vue?vue&type=script&lang=js"
export * from "./batch-query-info.vue?vue&type=script&lang=js"
import style0 from "./batch-query-info.vue?vue&type=style&index=0&id=73f315f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f315f4",
  null
  
)

export default component.exports